/* global MatgenGlobal,$ */

import { emit } from '../../common/helpers.js';

const init = () => {
  if (!MatgenGlobal.BaseEventsInitialized) {
    $(document).on('click', '#matgen-logout', async () => {
      MatgenGlobal.AuthUser.signOut({ global: true }, () => {
        MatgenGlobal.AuthUI();
      });
    });

    $(document).off('click', '#matgen-login-signup-link');
    $(document).on('click', '#matgen-login-signup-link', e => {
      e.preventDefault();
      if (MatgenGlobal.UI.a11yClick(e) === true) {
        $('#matgen-signin-modal').modal('hide');
        emit({ event: 'matgen-close-login-modal' });
        MatgenGlobal.UI.signUp();
      }
    });

    $(document).off('click', '#matgen-login-signup-link');
    $(document).on('click', '#matgen-login-signup-link', e => {
      e.preventDefault();
      $('#matgen-signin-modal').modal('hide');
      emit({ event: 'matgen-close-login-modal' });
      MatgenGlobal.MatgenUIFunctions.showSignupModal();
    });

    $(document).off('matgen-signin');
    $(document).on('matgen-signin', () => {
      MatgenGlobal.BaseInit();
    });

    $(document).off('click', '#matgen-signup-submit');
    $(document).on('click', '#matgen-signup-submit', async () => {
      $('#matgen-signup-modal').modal('hide');
      const signupForm = document.getElementById('matgen-signup-form');
      MatgenGlobal.AuthUserModule.validateSignup({
        email_element: document.getElementById('matgen-signup-email'),
        email_confirm_element: document.getElementById(
          'matgen-signup-email-confirm'
        ),
        password_element: document.getElementById('matgen-signup-password'),
        password_confirm_element: document.getElementById(
          'matgen-signup-password-confirm'
        ),
      });
      if (!signupForm.checkValidity()) {
        if (signupForm.reportValidity) {
          signupForm.reportValidity();
        } else {
          alert('Signup form invalid');
        }
      } else {
        const signup_response = await MatgenGlobal.MatgenPageLoader.start({
          message: 'Processing sign up',
          promise: MatgenGlobal.AuthUser.signUp(
            document.getElementById('matgen-signup-email').value,
            document.getElementById('matgen-signup-password').value,
            MatgenGlobal.base_config.tenant,
            {
              redirect: MatgenGlobal.base_config.RedirectURL,
              tenant: MatgenGlobal.base_config.tenant,
            }
          ),
        });
        if (
          signup_response === true ||
          signup_response.code === 'UsernameExistsException'
        ) {
          MatgenGlobal.UI.alertModal(
            'Signup Confirmation Sent',
            `
            <div class="alert alert-success" role="alert">
              Signup successful. To log in, you'll need to confirm your email address. Please check your email (allow a few minutes for delivery).
            </div>
          `
          );
        } else {
          MatgenGlobal.UI.handleError('Sign up error', signup_response.message);
        }
      }
    });

    $(document).off('submit', '#matgen-login-form');
    $(document).on('submit', '#matgen-login-form', async e => {
      e.preventDefault();
      const response = await MatgenGlobal.MatgenPageLoader.start({
        message: 'Logging in',
        group: 'matgen-login',
        promise: MatgenGlobal.AuthUser.signIn(
          $('#matgen-login-email').val(),
          $('#matgen-login-password').val()
        ),
      });
      if (
        response === true &&
        (window.location.hash === '' ||
          window.location.hash === '#' ||
          window.location.hash === '#*')
      ) {
        MatgenGlobal.AuthUI();
      } else if (response === 'NEW_PASSWORD_REQUIRED') {
        MatgenGlobal.UI.changePassword();
      } else if (response === 'RESET_PASSWORD_REQUIRED') {
        MatgenGlobal.UI.forgotPassword();
      } else if (response === 'UNCONFIRMED_EMAIL') {
        $('#matgen-resend-confirmation-link').show();
      } else {
        $('#matgen-login-form .form-error')
          .text(response.message)
          .show();
      }
    });

    $(document).off('click keypress', '#matgen-resend-confirmation-submit');
    $(document).on(
      'click keypress',
      '#matgen-resend-confirmation-submit',
      async e => {
        e.preventDefault();
        if (MatgenGlobal.UI.a11yClick(e) === true) {
          $('#matgen-signin-modal').modal('hide');
          emit({ event: 'matgen-close-login-modal' });
          MatgenGlobal.UI.resendConfirmationSubmit();
        }
      }
    );

    $(document).off('click keypress', '#matgen-forgot-password-submit');
    $(document).on(
      'click keypress',
      '#matgen-forgot-password-submit',
      async e => {
        if (MatgenGlobal.UI.a11yClick(e) === true) {
          e.preventDefault();
          MatgenGlobal.UI.validateForm('matgen-forgot-password-form', () => {
            $('#forgot-password-modal').modal('hide');
            MatgenGlobal.UI.forgotPasswordSubmit();
          });
        }
      }
    );

    $(document).off('click keypress', '#matgen-forgot-password-code');
    $(document).on(
      'click keypress',
      '#matgen-forgot-password-code',
      async e => {
        e.preventDefault();
        if (MatgenGlobal.UI.a11yClick(e) === true) {
          $(`#matgen-forgot-password-modal`).modal('hide');
          $('#matgen-signin-modal').modal('hide');
          emit({ event: 'matgen-close-login-modal' });
          MatgenGlobal.UI.confirmPassword();
        }
      }
    );

    $(document).off('click keypress', '#matgen-forgot-password-link');
    $(document).on(
      'click keypress',
      '#matgen-forgot-password-link',
      async e => {
        e.preventDefault();
        if (MatgenGlobal.UI.a11yClick(e) === true) {
          $('#matgen-signin-modal').modal('hide');
          emit({ event: 'matgen-close-login-modal' });
          MatgenGlobal.UI.forgotPassword();
        }
      }
    );

    $(document).off('click keypress', '#matgen-reset-password-link');
    $(document).on('click keypress', '#matgen-reset-password-link', async e => {
      e.preventDefault();
      if (MatgenGlobal.UI.a11yClick(e) === true) {
        $('#matgen-signin-modal').modal('hide');
        emit({ event: 'matgen-close-login-modal' });
        MatgenGlobal.UI.confirmPassword();
      }
    });

    $(document).off('click', '#matgen-reset-password-link');
    $(document).on('click', '#matgen-reset-password-link', e => {
      e.preventDefault();
      $('#matgen-signin-modal').modal('hide');
      emit({ event: 'matgen-close-login-modal' });
      MatgenGlobal.UI.confirmPassword();
    });

    $(document).off('click keypress', '#matgen-confirm-password-submit');
    $(document).on(
      'click keypress',
      '#matgen-confirm-password-submit',
      async e => {
        e.preventDefault();
        if (MatgenGlobal.UI.a11yClick(e) === true) {
          MatgenGlobal.UI.confirmPasswordSubmit();
        }
      }
    );

    $(document).off('click keypress', '#matgen-change-password-submit');
    $(document).on(
      'click keypress',
      '#matgen-change-password-submit',
      async e => {
        e.preventDefault();
        if (MatgenGlobal.UI.a11yClick(e) === true) {
          MatgenGlobal.UI.changePasswordSubmit();
        }
      }
    );

    $(document).off('click', '#matgen-resend-confirmation-link-submit');
    $(document).on('click', '#matgen-resend-confirmation-link-submit', e => {
      e.preventDefault();
      $('#matgen-resend-confirmation-link-modal').modal('hide');
      MatgenGlobal.AuthUserModule.resendConfirmationCode(
        $('#matgen-resend-confirmation-link-email').val()
      );
    });

    $(document).off('click', '#matgen-resend-confirmation-link');
    $(document).on('click', '#matgen-resend-confirmation-link', e => {
      e.preventDefault();
      $('#matgen-signin-modal').modal('hide');
      emit({ event: 'matgen-close-login-modal' });
      MatgenGlobal.UI.resendVerificationModal();
    });

    $(document).off('click', '#m4c-login, #m4c-save-prompt-login');
    $(document).on('click', '#m4c-login, #m4c-save-prompt-login', e => {
      e.preventDefault();
      $('#save-prompt-modal').modal('hide');
      MatgenGlobal.MatgenUIFunctions.showLoginModal();
    });

    $(document).off('click keypress', '#m4c-logout');
    $(document).on('click keypress', '#m4c-logout', e => {
      e.preventDefault();
      if (MatgenGlobal.UI.a11yClick(e) === true) {
        MatgenGlobal.AuthUser.signOut(false, () => {
          window.location.reload();
        });
      }
    });

    $(document).off('click keypress', '#m4c-mfa-disable');
    $(document).on('click keypress', '#m4c-mfa-disable', async e => {
      e.preventDefault();
      if (MatgenGlobal.UI.a11yClick(e) === true) {
        try {
          await MatgenGlobal.MatgenPageLoader.start({
            message: 'Disabling MFA',
            promise: MatgenGlobal.Amplify.Auth.setPreferredMFA(
              MatgenGlobal.AuthUser.user,
              'NOMFA'
            ),
          });
        } catch (e) {
          console.error(e);
          MatgenGlobal.UI.handleError(
            'API error',
            'There was an error changing your MFA settings, please try again or contact support.'
          );
        }
      }
    });

    $(document).off('click keypress', '#m4c-mfa');
    $(document).on('click keypress', '#m4c-mfa', e => {
      e.preventDefault();
      if (MatgenGlobal.UI.a11yClick(e) === true) {
        MatgenGlobal.UI.mfaSetupModal();
      }
    });

    $(document).off('click keypress', '#copy-mfa-code');
    $(document).on('click keypress', '#copy-mfa-code', e => {
      e.preventDefault();
      if (MatgenGlobal.UI.a11yClick(e) === true) {
        navigator.clipboard.writeText($('#mfa-text-code').text());
        MatgenGlobal.UI.alertModal(
          'Code copied',
          `<p>MFA code copied to clipboard.</p>`
        );
      }
    });

    $(document).off('click keypress', '#matgen-mfa-totp-submit');
    $(document).on('click keypress', '#matgen-mfa-totp-submit', async e => {
      e.preventDefault();
      if (MatgenGlobal.UI.a11yClick(e) === true) {
        $('#mfa-error-message').empty();
        const code = $('#matgen-mfa-totp').val();
        if (code && code !== '') {
          const user = MatgenGlobal.currentAuthenticatedUser;
          try {
            await MatgenGlobal.MatgenPageLoader.start({
              message: 'Verifying TOTP code',
              promise: MatgenGlobal.Amplify.Auth.verifyTotpToken(user, code),
            });
          } catch (e) {
            console.error(e);
            $('#mfa-error-message')
              .empty()
              .append(
                '<p>There was an error verifying the token or the token is invalid. Please try again or contact the help desk.</p>'
              );
          }

          try {
            await MatgenGlobal.MatgenPageLoader.start({
              message: 'Saving preferred MFA',
              promise: MatgenGlobal.Amplify.Auth.setPreferredMFA(user, 'TOTP'),
            });
          } catch (e) {
            console.error(e);
            $('#mfa-error-message')
              .empty()
              .append(
                '<p>There was an error finalizing your MFA settings. Please try again or contact the help desk.</p>'
              );
          }
        } else {
          $('#mfa-error-message')
            .empty()
            .append(
              '<p>You must enter the TOTP code from your chosen MFA application.</p>'
            );
        }
      }
    });

    $(document).off('click', '#matgen-login-submit');
    $(document).on('click', '#matgen-login-submit', async e => {
      e.preventDefault();
      if (MatgenGlobal.UI.a11yClick(e) === true) {
        emit({ event: 'matgen-login-submitted' });
        try {
          const response = await MatgenGlobal.MatgenPageLoader.start({
            message: 'Logging in',
            group: 'matgen-login',
            promise: MatgenGlobal.AuthUser.signIn(
              $('#m4c-login-email').val(),
              $('#m4c-login-password').val()
            ),
          });

          if (response !== true) {
            emit({ event: 'matgen-login-error' });
          }

          if (response === true) {
            $('#matgen-signin-modal').modal('hide');
            emit({ event: 'matgen-close-login-modal' });

            if (
              MatgenGlobal.AuthUser.user.challengeName === 'SOFTWARE_TOKEN_MFA'
            ) {
              MatgenGlobal.UI.totpModal();
            } else {
              if (
                MatgenGlobal.AuthCallback &&
                typeof MatgenGlobal.AuthCallback === 'function'
              ) {
                MatgenGlobal.AuthCallback();
              } else {
                if (MatgenGlobal.AuthUser.getUserRole() !== 'user') {
                  MatgenGlobal.Router.goTo('templates');
                } else {
                  MatgenGlobal.Router.goTo('materials');
                }
              }
            }
          } else if (response === 'NEW_PASSWORD_REQUIRED') {
            $('#matgen-signin-modal').modal('hide');
            emit({ event: 'matgen-close-login-modal' });
            MatgenGlobal.UI.changePassword();
          } else if (response === 'RESET_PASSWORD_REQUIRED') {
            $('#matgen-signin-modal').modal('hide');
            emit({ event: 'matgen-close-login-modal' });
            MatgenGlobal.UI.forgotPassword();
          } else if (response === 'UNCONFIRMED_EMAIL') {
            $('#matgen-resend-confirmation-link').show();
            $('#matgen-signin-modal .modal-body')
              .prepend(
                $(
                  `
                <div class="alert alert-danger" role="alert">
                  User email not verified. Please check your email and click the verification link, or use the resend link below to resend.
                </div>
              `
                )
              )
              .show();
          } else {
            $('#sign-in-error').remove();
            $('#matgen-signin-modal .modal-body').prepend(
              $(`
              <div id="sign-in-error" class="alert alert-danger" role="alert">
                User credentials not recognized. Please check your information and try again.
              </div>
            `)
            );
          }
        } catch (e) {
          console.error(e);
          MatgenGlobal.UI.handleError(
            'Authentication error',
            'There was an error during authentication. Please try again later or contact support.'
          );
        }
      }
    });

    $(document).off('click', '#matgen-totp-submit');
    $(document).on('click', '#matgen-totp-submit', async e => {
      e.preventDefault();
      try {
        MatgenGlobal.AuthUser.user = await MatgenGlobal.MatgenPageLoader.start({
          message: 'Confirming MFA code',
          promise: MatgenGlobal.Amplify.Auth.confirmSignIn(
            MatgenGlobal.AuthUser.user,
            $('#matgen-totp').val(),
            'SOFTWARE_TOKEN_MFA'
          ),
        });
        $('#matgen-totp-modal').modal('hide');
        if (
          MatgenGlobal.AuthCallback &&
          typeof MatgenGlobal.AuthCallback === 'function'
        ) {
          MatgenGlobal.AuthCallback();
        } else {
          if (MatgenGlobal.AuthUser.getUserRole() !== 'user') {
            MatgenGlobal.Router.goTo('templates');
          } else {
            MatgenGlobal.Router.goTo('materials');
          }
        }
      } catch (e) {
        console.error(e);
        MatgenGlobal.UI.handleError(
          'Authentication error',
          'There was an error during authentication. Please try again later or contact support.'
        );
      }
    });

    $(document).off('click', '#m4c-save-prompt-quit');
    $(document).on('click', '#m4c-save-prompt-quit', async e => {
      e.preventDefault();
      $('#save-prompt-modal').modal('hide');
    });

    $(document).off('click', '#m4c-signup, #m4c-save-prompt-signup');
    $(document).on('click', '#m4c-signup, #m4c-save-prompt-signup', async e => {
      e.preventDefault();
      $('#save-prompt-modal').modal('hide');
      MatgenGlobal.MatgenUIFunctions.showSignupModal();
    });

    $(document).off('click', '#m4c-signup-submit');
    $(document).on('click', '#m4c-signup-submit', async e => {
      if (MatgenGlobal.UI.a11yClick(e) === true) {
        $('#signup-error-message').remove();
        const signupForm = document.getElementById('m4c-signup-form');
        MatgenGlobal.AuthUserModule.validateSignup({
          email_element: $('#m4c-signup-email')[0],
          email_confirm_element: $('#m4c-signup-email-confirm')[0],
          password_element: $('#m4c-signup-password')[0],
          password_confirm_element: $('#m4c-signup-password-confirm')[0],
        });
        if (!signupForm.checkValidity()) {
          if (signupForm.reportValidity) {
            signupForm.reportValidity();
          } else {
            alert('Signup form invalid');
          }
        } else {
          const metadata = {};
          if (MatgenGlobal.amplify_config_vars.redirectSignIn) {
            metadata.redirect = MatgenGlobal.amplify_config_vars.redirectSignIn;
          }
          const response = await MatgenGlobal.MatgenPageLoader.start({
            message: 'Processing signup',
            promise: MatgenGlobal.AuthUser.signUp(
              document.getElementById('m4c-signup-email').value,
              document.getElementById('m4c-signup-password').value,
              MatgenGlobal.tenant,
              metadata
            ),
          });

          if (response === true) {
            $('#m4c-signup-modal').modal('hide');

            MatgenGlobal.UI.alertModal(
              'Signup complete',
              `
              <p>You have successfully registered. An email has been sent to the submitted address.  <i>If you do not see it, be sure to check your spam or junk folder, as it may have been mistakenly filtered.</i>  You must confirm your email address to complete the signup process.</p>`
            );
            emit({ event: 'matgen-create-account' });
          } else {
            const errDiv = $(
              `<div id="signup-error-message" class="alert alert-danger" role="alert">
                ${response.message}
              </div>`
            );
            errDiv.insertBefore('#m4c-signup-form');
          }
        }
      }
    });

    $(document).off('change', 'select');
    $(document).on('change', 'select', e => {
      if (
        $(e.currentTarget)
          .find('option:selected')
          .hasClass('default')
      ) {
        $(e.currentTarget).css('color', '#aaa');
      } else {
        $(e.currentTarget).css('color', 'inherit');
      }
    });

    $(document).on('click', () => {
      MatgenGlobal.hideTooltips();
    });

    MatgenGlobal.BaseEventsInitialized = true;
  }
};

export { init };
